<template>
	<wt-selector :options="options" v-model="Value" :clearable="true" :allow-create="true" :filterable="true"></wt-selector>
</template>
<script>
export default {
  name: 'order-sampleType-selector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      let params = { page: 0, size: 99999999 }
      let options = []
      this.$store.dispatch('getCorpusSuiteName', params).then(data => {
        data.forEach(ele => {
          let obj = {
            label: ele,
            value: ele
          }
          options.push(obj)
        })
        this.options = options
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
